import React, { useState } from 'react';
import PropTypes, { InferProps } from 'prop-types';
import ComponentWithDrawer
  from '@fuww/library/src/Navigation/withDrawerState';
import FashionUnited from '@fuww/library/src/Icons/FashionUnited';
import Anchor from '@fuww/library/src/Anchor';
import dynamic from 'next/dynamic';
import SimpleTopAppBar from './SimpleTopAppBar';
import { Link } from '../../routes.mjs';
import getRelativePrefix from '../../lib/getRelativePrefix.mjs';
import { useSiteContext } from '../SiteContext';
import loading from '../../lib/fullScreenLoading';

const DynamicDrawer = dynamic(() => import('./Drawer'), {
  ssr: false,
  loading,
});

const navigationProperties = {
  topAppBarTitle: PropTypes.node,
  useRouter: PropTypes.bool,
  isExecutive: PropTypes.bool,
};

type NavigationProperties = PropTypes.InferProps<typeof navigationProperties>;

const Navigation = ({
  topAppBarTitle,
  useRouter,
  isExecutive,
} : NavigationProperties) => {
  const [open, setOpen] = useState(false);

  const toggleDrawer = () => {
    setOpen((previousOpen) => !previousOpen);
  };

  return (
    <>
      <SimpleTopAppBar
        onOpenDrawer={toggleDrawer}
        topAppBarTitle={topAppBarTitle}
        useRouter={useRouter ?? true}
        isExecutive={isExecutive}
      />
      <DynamicDrawer
        open={open}
        closeDrawer={toggleDrawer}
      />
    </>
  );
};

Navigation.propTypes = navigationProperties;

const NavigationWithDrawer = ComponentWithDrawer(Navigation);

const indexPropertyTypes = {
  isExecutive: PropTypes.bool,
};

type IndexProperties = InferProps<typeof indexPropertyTypes>;

const Index = ({ isExecutive }: IndexProperties) => {
  const { url } = useSiteContext();
  const relativePrefix = getRelativePrefix(url);

  return (
    <NavigationWithDrawer
      topAppBarTitle={(
        <Link
          route="index"
          href={relativePrefix}
          passHref
        >
          <Anchor styled>
            <FashionUnited
              width="168"
              height="18"
              title="FashionUnited"
            />
          </Anchor>
        </Link>
      )}
      isExecutive={isExecutive}
    />
  );
};

Index.propTypes = indexPropertyTypes;

export default Index;
